import { connect } from "react-redux";
import DisplayActions from "../../../../redux/DisplayRedux";
import UserAccountActions from "../../../../redux/UserAccountRedux";
import CampaignDetail from "../components/detail/CampaignDetail";

const mapStateToProps = ({ display, userAccount }) => ({
  user: userAccount.user,
  token: userAccount.token,
  isSuperUser: userAccount.isSuperUser,
  currentCampaign: display.currentCampaign,
  fetchingCampaign: display.fetchingCampaign,
  payments: display.payments,
  fetchingPayments: display.fetchingPayments,
  deletingPayment: display.deletingPayment,
  errors: display.errors,
  reportToken: display.reportToken,
  loadingReport: display.loadingReport,
  reportSingleData: display.reportSingleData,
  loadingSingleReport: display.loadingSingleReport,
  proposalToken: display.proposalToken,
  loadingProposal: display.loadingProposal,
  proposalAudience: display.proposalAudience,
  editCampaignActive: display.editCampaignActive,
  cart: display.cart,
  categories: display.categories,
  fetchingDisplaysInfo: display.fetchingDisplaysInfo,
  replicateCampaignId: display.replicateCampaignId,
  replicatingCampaign: display.replicatingCampaign,
  campaignStats: display.campaignStats,
  loadingStats: display.loadingStats,
  conversionRates: display.conversionRates,
  isEditingCampaignDate: display.isEditingCampaignDate,
  editCampaignDateErrors: display.editCampaignDateErrors,
});

const mapStateToDispatch = (dispatch) => ({
  getCampaign: (id) => dispatch(DisplayActions.getCampaignRequest(id)),
  getCampaignPayments: (id) =>
    dispatch(DisplayActions.getCampaignPaymentsRequest(id)),
  getCampaignStats: (id) => dispatch(DisplayActions.getCampaignStatsRequest(id)),
  getConversionRates: () => dispatch(DisplayActions.getConversionRatesRequest()),
  deletePayment: (id) => dispatch(DisplayActions.deletePaymentRequest(id)),
  getReportRequest: (reportData) =>
    dispatch(DisplayActions.getReportRequest(reportData)),
  getSingleReportRequest: (params) =>
    dispatch(DisplayActions.getSingleReportRequest(params)),
  getProposalRequest: (proposalData) =>
    dispatch(DisplayActions.getProposalRequest(proposalData)),
  getProposalAudience: (data) =>
    dispatch(DisplayActions.getProposalAudienceRequest(data)),
  editCampaign: (campaignId, params) =>
    dispatch(DisplayActions.editCampaignRequest(campaignId, params)),
  editCampaignDate: (campaignId, params) =>
    dispatch(DisplayActions.editCampaignDateRequest(campaignId, params)),
  activateEditCampaign: (campaign) =>
    dispatch(DisplayActions.activateEditCampaign(campaign)),
  clearCampaignData: (id) => dispatch(DisplayActions.clearCampaignData(id)),
  setShouldPromptLogin: (value, target) =>
    dispatch(UserAccountActions.setShouldPromptLogin(value, target)),
  logout: () => dispatch(UserAccountActions.userLogout()),
  setNewVersionCampaign: (v) => dispatch(DisplayActions.setNewVersionCampaign(v)),
  replicateCampaign: (campaignId, params) =>
    dispatch(DisplayActions.createReplicateCampaignRequest(campaignId, params)),
  setDefaultContent: (content) => dispatch(DisplayActions.setDefaultContent(content)),
  removeDisplayFromCart: (displayId) => dispatch(DisplayActions.removeDisplayFromCart(displayId)),
  setCampaignName: (name) => dispatch(DisplayActions.setCampaignName(name)),
  setClient: (client) => dispatch(DisplayActions.setClient(client)),
  setBrand: (brand) => dispatch(DisplayActions.setBrand(brand)),
  setBudget: (amount) => dispatch(DisplayActions.setBudget(amount)),
  setDates: (from, to) => dispatch(DisplayActions.setDates(from, to)),
  setProgrammatic: (p) => dispatch(DisplayActions.setProgrammatic(p)),
  updateBundles: (listBundle) => dispatch(DisplayActions.updateBundles(listBundle)),
  getCategories: () => dispatch(DisplayActions.getCategoriesRequest()),
  setToleranceResolution: (t) => dispatch(DisplayActions.setToleranceResolution(t)),
  setToleranceResolutionInit: (t) => dispatch(DisplayActions.setToleranceResolutionInit(t)),
  getDisplaysInfoRequest: (params) => dispatch(DisplayActions.getDisplaysInfoRequest(params)),
  updateCustomContentRequestActive: (id, displayId, relationId, active) =>
    dispatch(DisplayActions.updateCustomContentRequest(id, displayId, relationId, null, active)),
  addCustomContentFromCampaign: (
    relationId,
    indice_relation,
    active,
    displayId,
    fill_screen,
    revision_status,
    isPendingContent,
    isContentMixed,
    promised_shows,
    length,
    content,
    rules,
    subsidized_price,
    promised_shows_subsidized,
    content_name,
    cpm,
    programmatic_volume_discount_apply,
    programmatic_volume_discounts,
    promised_shows_discounted,
    is_secured_investment
  ) =>
    dispatch(
      DisplayActions.addCustomContentFromCampaign(
        relationId,
        indice_relation,
        active,
        displayId,
        fill_screen,
        revision_status,
        isPendingContent,
        isContentMixed,
        promised_shows,
        length,
        content,
        rules,
        subsidized_price,
        promised_shows_subsidized,
        content_name,
        cpm,
        programmatic_volume_discount_apply,
        programmatic_volume_discounts,
        promised_shows_discounted,
        is_secured_investment,
        is_secured_investment
      )
    ),
});

export default connect(mapStateToProps, mapStateToDispatch)(CampaignDetail);
